<template>
<div class="chapter">
<div class="inner_page">
<h2 id="INTRODUCTION">INTRODUCTION.</h2>
<p class="calibre3">The book to which these lines form an introduction is a peculiar
one in many respects. It is a story, but it is a true story, and
written years ago with little idea that it would ever come into this
form. The writer has been induced, only recently, by the advice
of friends and by his own feeling that such a production would be
appreciated, to present what, at the time it was being made up,
was merely a means of occupying a mind which had to contemplate,
besides, only the horrors of a situation from which death
would have been, and was to thousands, a happy relief.</p>
<p class="calibre3">The original diary in which these writings were made from day
to day was destroyed by fire some years after the war, but its contents
had been printed in a series of letters to the Jackson, (Mich.)
<cite>Citizen</cite>, and to the editor and publisher of that journal thanks are
now extended for the privilege of using his files for the preparation
of this work. There has been little change in the entries in
the diary, before presenting them here. In such cases the words
which suggest themselves at the time are best—they cannot be improved
upon by substitution at a later day.</p>
<p class="calibre3">This book is essentially different from any other that has been
published concerning the “late war” or any of its incidents. Those
who have had any such experience as the author will see its truthfulness
at once, and to all other readers it is commended as a statement
of actual things by one who experienced them to the fullest.</p>
<p class="calibre3">The annexed list of the Andersonville dead is from the rebel
official records, is authentic, and will be found valuable in many
pension cases and otherwise.</p>
<div class="calibre illowe10 figure" id="i_008">
<img alt="Good Luck charm" class="calibre6" id="id-4122828965160073441" src="Images/img0002.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?6287249e